import React, { useState } from 'react';
import { MagnesiumOxideProcedure } from './MagnesiumOxideProcedure';
import { MagnesiumOxideTable } from './MagnesiumOxideTable';
import { MagnesiumOxideChart } from './MagnesiumOxideChart';
import { Table2, LineChart, SlidersHorizontal } from 'lucide-react';
import { useMagnesiumOxideStore } from '../store/useMagnesiumOxideStore';

export function MagnesiumOxideSidebar() {
  const [tab, setTab] = useState<'controls' | 'data' | 'chart'>('controls');
  const crucibleTempC = useMagnesiumOxideStore(s => s.crucibleTempC);
  const labStage = useMagnesiumOxideStore(s => s.labStage);

  const activeClass = "interactable-btn flex-1 flex justify-center items-center gap-2 py-2.5 bg-amber-600 text-white font-semibold rounded-lg shadow-md transition-all";
  const inactiveClass = "interactable-btn flex-1 flex justify-center items-center gap-2 py-2.5 text-muted-foreground hover:text-foreground hover:bg-muted font-medium transition-all cursor-pointer";

  return (
    <div className="w-full lg:w-[400px] xl:w-[450px] shrink-0 lg:h-full bg-card/95 backdrop-blur-xl border-t lg:border-t-0 lg:border-l border-amber-500/10 flex flex-col shadow-[0_0_50px_rgba(0,0,0,0.5)] z-20">
      <div className="p-4 border-b border-amber-500/10">
        <div className="grid grid-cols-3 bg-muted/40 p-1 rounded-xl border border-border shadow-inner gap-1">
          <div className={tab === 'controls' ? activeClass : inactiveClass} onClick={() => setTab('controls')}>
            <SlidersHorizontal className="w-4 h-4" /><span className="text-xs sm:text-sm">Controls</span>
          </div>
          <div className={tab === 'data' ? activeClass : inactiveClass} onClick={() => setTab('data')}>
            <Table2 className="w-4 h-4" /><span className="text-xs sm:text-sm">Data</span>
          </div>
          <div className={tab === 'chart' ? activeClass : inactiveClass} onClick={() => setTab('chart')}>
            <LineChart className="w-4 h-4" /><span className="text-xs sm:text-sm">Chart</span>
          </div>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto overflow-x-hidden p-4 sm:p-6 customized-scrollbar flex flex-col">
        {tab === 'controls' && (
          <div className="flex-1 flex flex-col pt-2">
            <MagnesiumOxideProcedure />
            <div className="mt-auto pt-6">
              <div className="flex justify-between items-center bg-background/50 p-4 rounded-2xl border border-border/50 shadow-inner">
                <div className="flex flex-col">
                  <span className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-1">Crucible Temp</span>
                  <div className="text-3xl font-mono font-bold text-amber-500 tracking-tight" style={{ textShadow: '0 0 15px rgba(245,158,11,0.35)' }}>
                    {crucibleTempC.toFixed(0)}°C
                  </div>
                </div>
                <div className="w-[1px] h-12 bg-border/50 mx-4" />
                <div className="flex flex-col text-right">
                  <span className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-1">Stage</span>
                  <div className="text-lg font-semibold text-orange-500 tracking-tight capitalize">
                    {labStage.replace(/-/g, ' ')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {tab === 'data' && <MagnesiumOxideTable />}
        {tab === 'chart' && <div className="flex-1 flex flex-col h-full min-h-[400px]"><MagnesiumOxideChart /></div>}
      </div>
    </div>
  );
}

export default MagnesiumOxideSidebar;
